// Centralized data-testid registry for GAELON
export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkCapabilities: "nav-link-capabilities",
  linkTechnology: "nav-link-technology",
  linkShowcase: "nav-link-showcase",
  linkPhilosophy: "nav-link-philosophy",
  linkContact: "nav-link-contact",
  ctaBookCall: "nav-cta-book-call",
  languageSelector: "language-selector",
  languageOption: (code) => `language-option-${code}`,
  mobileMenuToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  subheadline: "hero-subheadline",
  ctaBookCall: "hero-cta-book-call",
  ctaExplore: "hero-cta-explore",
  scrollHint: "hero-scroll-hint",
};

export const MISSION = {
  section: "mission-section",
  statement: "mission-statement",
};

export const CAPABILITIES = {
  section: "capabilities-section",
  card: (slug) => `capability-card-${slug}`,
};

export const TECHNOLOGY = {
  section: "technology-section",
  node: (slug) => `technology-node-${slug}`,
};

export const SHOWCASE = {
  section: "showcase-section",
  stat: (slug) => `showcase-stat-${slug}`,
};

export const PHILOSOPHY = {
  section: "philosophy-section",
};

export const GLOBAL_PRESENCE = {
  section: "global-presence-section",
  region: (slug) => `global-region-${slug}`,
};

export const FINAL_CTA = {
  section: "final-cta-section",
  button: "final-cta-button",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  message: "contact-textarea-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
};

export const NEWSLETTER = {
  form: "newsletter-form",
  email: "newsletter-input-email",
  submit: "newsletter-submit-button",
  success: "newsletter-success-message",
};

export const FOOTER = {
  root: "footer-root",
  social: (slug) => `footer-social-${slug}`,
  copyright: "footer-copyright",
};
